import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';


const TagsFilter = ({
   tagsData,
   onChange,
   wrapperId = 'dashboard-sitedesing-preview',
   selectedValue = [],
   primaryColor,
   isNextApp,
}) => {
   const listWrapperRef = useRef()
   const [lastIndex, setLastIndex] = useState(0)
   const [isShowMore, setIsShowMore] = useState(false)
   const tagItemHeight = 36


   useEffect(() => {
      const calculateLastShowIndex = () => {
         try {
            const listWrapperElement = listWrapperRef.current
            if(!listWrapperElement) return;

            let wrapperWidth = isNextApp ? (window.innerWidth - 48) : document.querySelector(`#${ wrapperId }`)?.offsetWidth || 0
            const screenWidth = window.innerWidth

            const isMobile = screenWidth <= 1024

            if(screenWidth <= 768) {
               wrapperWidth = wrapperWidth - 32
            }

            if(isMobile) {
               wrapperWidth = 2 * wrapperWidth
            }

            const moreButtonWidth = lastIndex < tagsData.length - 1 ? 68 : 0;
            let calculatedWidth = 0;
            let newLastIndex = 0;

            let isOffsetTopCounted = false

            Array.from(listWrapperElement.children).forEach((childElement, index) => {
               if('BUTTON' === childElement.tagName) return;
               const tagElementWidth = childElement.offsetWidth + 8; // Tag width + gap

               if((calculatedWidth + tagElementWidth + moreButtonWidth) < wrapperWidth && !isMobile) {
                  newLastIndex = index
               }

               if(isMobile && !isOffsetTopCounted && childElement.offsetTop !== listWrapperElement.children[0].offsetTop) {
                  isOffsetTopCounted = true
                  calculatedWidth = wrapperWidth / 2
               }

               if((calculatedWidth + tagElementWidth + moreButtonWidth) < wrapperWidth && isMobile) {
                  newLastIndex = index
               }

               calculatedWidth = calculatedWidth + tagElementWidth
            });
            setLastIndex(newLastIndex)
         } catch (error) {
            console.log(error);
         }
      }
      calculateLastShowIndex()

      window.addEventListener('resize', calculateLastShowIndex)

      return () => {
         window.removeEventListener('resize', calculateLastShowIndex)
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [tagsData, isNextApp])

   const getItemStyle = (isActive) => {
      let style = {
         backgroundColor: '#fff',
         height: `${ tagItemHeight }px`,
      }
      if(isActive){
         style = {
            ...isActive,
            backgroundColor: primaryColor,
         }
      }
      return { ...style }
   }

   return (
      <div
         className='w-full flex flex-wrap items-center gap-2 mb-[18px] px-4 md:px-0'
         ref={ listWrapperRef }
      >
         {
            tagsData && tagsData.map((tag, index) => {
               if(lastIndex && index > lastIndex && !isShowMore) return null;
               const isActive = selectedValue.includes(tag.id);
               return (
                  <div
                     key={ tag.id }
                     role='presentation'
                     onClick={ () => onChange(tag.id) }
                     style={ { ...getItemStyle(isActive) } }
                     className={ `${ isActive ? 'text-major-dark' : 'dark:bg-panel-dark dark:border-divider-dark' } rounded-full flex items-center justify-center px-3 cursor-pointer whitespace-nowrap` }

                  >
                     <span className='text-sm dark:text-major-dark'> { tag.name }</span>
                  </div>
               );
            })
         }
         {
            lastIndex < tagsData.length - 1 && (
               <Button
                  text={ isShowMore ? 'Less tags' : 'More tags' }
                  backgroundColor='transparent'
                  padding='none'
                  textColor='secondary dark:text-secondary-dark'
                  classNames='!w-fit !h-[fit-content]'
                  textSize='small'
                  textMarginX='0'
                  onClick={ () => setIsShowMore(!isShowMore) }
               />
            )
         }
      </div>
   )
}

TagsFilter.propTypes = {
   tagsData: PropTypes.array,
   onChange: PropTypes.func,
   wrapperId: PropTypes.string,
   selectedValue: PropTypes.array,
   primaryColor: PropTypes.string,
   isNextApp: PropTypes.bool,
}

export default TagsFilter;
